import { Stack, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';

const ComingSoon = () => {
    const theme = useTheme();

    return (
        <Stack direction="row" alignItems="center" justifyContent='center' gap={0} sx={{ color: theme.palette.text.secondary }}>
            <HourglassBottomIcon fontSize='large' />
            <Typography variant='h4' sx={{ textAlign: 'center' }}>
                Coming soon...
            </Typography>
        </Stack>
    )
}

export default ComingSoon